import {
  BRAND_LOGO_VARIANT,
  BrandLogoVariant
} from "@arbolus-technologies/models/common";

import arbolusLogoFullSquare from "../assets/arbolus-logo-full-square.svg";
import arbolusLogoFullWhite from "../assets/arbolus-logo-full-white.svg";
import arbolusLogoFull from "../assets/arbolus-logo-full.svg";
import arbolusMarkSquare from "../assets/arbolus-mark-square.svg";
import arbolusMarkWhite from "../assets/arbolus-mark-white.svg";
import arbolusMark from "../assets/arbolus-mark.svg";

const BRAND_LOGOS: Record<BrandLogoVariant, string> = {
  [BRAND_LOGO_VARIANT.Full]: arbolusLogoFull,
  [BRAND_LOGO_VARIANT.FullWhite]: arbolusLogoFullWhite,
  [BRAND_LOGO_VARIANT.Mark]: arbolusMark,
  [BRAND_LOGO_VARIANT.MarkSquare]: arbolusMarkSquare,
  [BRAND_LOGO_VARIANT.MarkWhite]: arbolusMarkWhite,
  [BRAND_LOGO_VARIANT.Avatar]: arbolusLogoFullSquare
};

/**
 * Returns the Arbolus logo asset for the given variant.
 */
export function getBrandLogo(
  variant: BrandLogoVariant = BRAND_LOGO_VARIANT.Full
): string {
  return BRAND_LOGOS[variant];
}
